import "./clipboard-copy-input.scss";
import IconCopy from "../../icons/icon-copy/icon-copy";
import { Input } from "../input/input";

interface IProps {
    value: string;
    placeholder?: string
}
export const ClipboardCopyInput: React.FC<IProps> = ({ value, placeholder }) => (
    <div className='clipboard-copy-input-container'>
        <Input value={value}
            placeholder={placeholder}
            disabled
            button={{
                iconComp: IconCopy,
                onClick: () => navigator.clipboard.writeText(value),
            }}
        />
    </div>
);
